import { applicationContextActionCreator } from '../store/actions';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import ServiceBase from './ServiceBase';

class MessageService extends ServiceBase {

    async getMessages(queryItems) {
        var result = await this.requestJson({
            url: '/api/message',
            method: "GET",
            data: queryItems
        });

        return result;
    }

    async getMessage(id) {
        var result = await this.requestJson({
            url: `/api/message/${id}`,
            method: "GET"
        });

        return result;
    }

    async createMessage(message) {
        var result = await this.requestJson({
            url: `/api/message`,
            method: "POST",
            data: message
        });
        return result;
    }

    async updateAudiencePreference(userId, messageId, subscribed = true) {
        var callResponse = await this.requestJson({
            url: `/api/message/${messageId}/subscription`,
            method: "POST",
            data: { "userId": userId, "messageid": messageId, "subscribed": subscribed }
        });
        return callResponse;
    }

    async getFile(messageId, id) {

        let callResponse = undefined;

        let webapi = `api/message/${messageId}/attachment/${id}`;
        const token = this.getToken();
        callResponse = fetch(webapi,
            {
                method: 'GET',
                headers: {
                    responseType: 'blob',
                    authorization: token
                }
            })
            .then(response =>
                response.blob()
            )
            .then(blob => {
                if (blob.size > 0) {
                    let objUrl = URL.createObjectURL(blob);
                    return { result: true, model: objUrl };
                } else {
                    return { result: false };
                }
            });

        return callResponse;
    }

    async attachFiles(formData, messageId) {
        var result = await this.sendFormData({
            url: `/api/message/${messageId}/attachments/`,
            method: "POST",
            data: formData
        });

        return result;
    }
}

export default MessageService;